import React from 'react';
import { TableRow, TableCell, Skeleton } from '@mui/material';
import { TableColumn } from './TableWithActions';

interface TableSkeletonProps<T> {
  columns: TableColumn<T>[];
  rowCount?: number;
  hasRowActions?: boolean;
  animate?: boolean;
}

export const TableSkeleton = <T,>({
  columns,
  rowCount = 10,
  hasRowActions = false,
  animate = true,
}: TableSkeletonProps<T>) => {
  return (
    <>
      {Array.from({ length: rowCount }, (_, index) => (
        <TableRow key={`skeleton-${index}`}>
          {columns.map((_, columnIndex) => (
            <TableCell key={`skeleton-cell-${index}-${columnIndex}`}>
              <Skeleton
                variant="text"
                width={
                  columnIndex === 0
                    ? '60%' // First column usually wider (names, titles)
                    : columnIndex === columns.length - 1
                      ? '40%' // Last column usually smaller (dates, status)
                      : '50%' // Middle columns medium width
                }
                height={20}
                animation={animate ? 'wave' : false}
                sx={{
                  // Add slight delay for staggered effect
                  animationDelay: animate ? `${index * 100 + columnIndex * 50}ms` : '0ms',
                }}
              />
            </TableCell>
          ))}
          {hasRowActions && (
            <TableCell align="right">
              <Skeleton
                variant="circular"
                width={24}
                height={24}
                animation={animate ? 'wave' : false}
                sx={{
                  animationDelay: animate ? `${index * 100 + columns.length * 50}ms` : '0ms',
                }}
              />
            </TableCell>
          )}
        </TableRow>
      ))}
    </>
  );
};
